import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const commonApi = {
  state: {

  },
  mutations: {
    getInsuranceInfoList(state, data) {
      data.url = API.common.insurance_info_list
      CommonUtils.GetRequest(data)
    },
    getInsuranceInfoListStore(state, data) {
      data.url = API.common.insurance_alias_list_store
      CommonUtils.PostRequest(data)
    },
    getInsuranceAliasList(state, data) {
      data.url = API.common.alias_list
      CommonUtils.GetRequest(data)
    },
    getCommissionVerifyGetInfo(state, data) {
      data.url = API.common.commission_verify_get_info
      CommonUtils.GetRequest(data)
    },
    getCommissionVerifyStore(state, data) {
      data.url = API.common.commission_verify_store
      CommonUtils.PostRequest(data)
    },
    getProductConnectionPlate(state, data){
      data.url = API.common.get_product_connection_plate
      CommonUtils.GetRequest(data)
    },
    cancelProductConnect (state, data) {
      data.url = API.common.cancelProductConnect
      CommonUtils.PostRequest(data)
    },
    FetchCpsBranchList(state, data) {
      data.url = API.common.cps_branch_list
      CommonUtils.GetRequest(data)
    },
    FetchCpsBranchStore(state, data) {
      data.url = API.common.cps_branch_store
      CommonUtils.PostRequest(data, true)
    },
    FetchCpsBranchShow(state, data) {
      data.url = API.common.cps_branch_show
      CommonUtils.GetRequest(data)
    },
    FetchCpsBranchDelete(state, data) {
      data.url = API.common.cps_branch_delete
      CommonUtils.GetRequest(data)
    },
    FetchSimulateInfo(state, data){
      data.url = API.common.simulate_login
      CommonUtils.PostRequest(data)
    },
    FetchGetAdminPasswordStatus(state, data) {
      data.url = API.common.getAdminPasswordStatus
      CommonUtils.GetRequest(data)
    },
    getProvinceCityData(state, data) {
      data.url = API.common.getProvinceCityData
      CommonUtils.GetRequest(data)
    }

  }
}

export default commonApi



// WEBPACK FOOTER //
// ./src/store/modules/common.js